export default __webpack_public_path__ + "static/MichaelSatz-a6af1b9f4d4c76055934953c57f0e095.jpg";